<script setup>
import { ref, computed, watch, onMounted } from 'vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});

const svgContent = ref(null);
const isSvg = computed(() =>
  props.data?.image?.src?.toLowerCase().endsWith('.svg'),
);

// Функція завантаження зовнішнього SVG
const fetchSvg = async () => {
  if (!isSvg.value || !props.data?.image?.src) return;

  try {
    const response = await fetch(props.data.image.src);
    if (response.ok) {
      svgContent.value = await response.text();
    }
  } catch (e) {
    console.error('Помилка завантаження зовнішнього SVG:', e);
  }
};

onMounted(fetchSvg);
watch(() => props.data?.image?.src, fetchSvg);
</script>

<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data.background_color}` : '',
      data?.spacing?.top
        ? `section--top-${data.spacing.top}`
        : 'section--top-xl',
      data?.spacing?.bottom
        ? `section--bottom-${data.spacing.bottom}`
        : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="title-image">
        <h2
          v-if="data?.title && data?.title.length > 0"
          :class="[
            'mb-0 h2 title-image__title text-center',
            data?.background_color === 'black' ? 'white' : 'black',
          ]"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data.title"
        ></h2>
        <template v-if="data?.image && data?.image?.src">
          <div
            v-if="isSvg && svgContent"
            class="title-image__image title-image__image--svg"
            data-aos="zoom-in"
            data-aos-easing="ease-out-quad"
            v-html="svgContent"
          ></div>

          <NuxtImg
            v-else
            :src="data.image.src"
            :alt="data.image.alt"
            :height="data.image.height"
            :width="data.image.width"
            class="title-image__image"
            data-aos="zoom-in"
            data-aos-easing="ease-out-quad"
            loading="lazy"
          />
        </template>
      </div>
    </div>
  </section>
</template>
<style scoped lang="scss">
.title-image {
  $parent: &;
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0 auto;
    @include media-breakpoint-up(md) {
      max-width: 66%;
    }
  }
  &__image {
    height: auto;
    width: 100%;
    &--svg {
      display: flex;
      justify-content: center;
    }
    &:deep(svg) {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
